

import groupDiscussion from "../../../assets/images/groupDiscussion.png";

interface BottomMessageProps{
    visible: boolean;
    message: string;
    onClose: () => void;
}

const BottomMessageWithIcon = ({ visible, message, onClose }:BottomMessageProps) => {
  if (visible) {
    return (
      <div
        className="absolute bottom-0 m-[4%] max-w-[92%] min-w-[80%]"
      >
        <div
          className="bg-[rgba(95,72,138,0.75)] self-start rounded-[4%] rounded-bl-[0%] rounded-br-[0%] px-[4%] py-[1.5%] ml-[4%]"
        >
          <img
            src={groupDiscussion}
            alt="Group Discussion"
            className="h-[6%] w-[6%] object-contain"
          />
        </div>
        <div
          className="bg-[rgba(95,72,138,0.75)] flex flex-row p-[4%] rounded-[2%] items-center"
        >
          <span
            className="text-white text-base font-bold mr-[4%]"
            style={{ fontFamily: "'Lato', sans-serif" }}
          >
            {message}
          </span>
          <button
            onClick={() => {
              if (onClose) {
                onClose();
              }
            }}
            className="mr-[20%]"
          >
            <img
              src="/assets/XCircle.png"
              alt="Close"
              className="h-[6%] w-[6%] object-contain"
            />
          </button>
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};

export default BottomMessageWithIcon;